export default "__VITE_ASSET__Crj1pr2Q__"